import { CellContext } from '@tanstack/react-table'
import { formatUsd } from 'utils/formatting'

export const USDCell = <T, U extends string>(info: CellContext<T, U>) => {
  const value = info.getValue()
  return value ? formatUsd(parseFloat(value)) : '-'
}
